<template>
  <collapse-default id="registro">
    <template v-slot:header>
      Registro {{ propData.registro.registro_id ? '' : '- Não informado' }}
    </template>

    <template v-slot:content>
      <div v-if="propData.registro"
           class="mt-3 pl-3 pr-3 pb-2">
        <div class="row">
          <div class="col-2 col-sm-3">
            <label class="resumo-show_label"
                   for="">Nome do Digitador</label>
            <div class="resumo-show_sublabel">
              {{ propData.registro && propData.registro.digitador || 'Não informado' }}
            </div>
          </div>
          <div class="col-2">
            <label class="resumo-show_label"
                   for="">Escrevente</label>
            <div class="resumo-show_sublabel">
              {{ propData.registro && propData.registro.escrevente || 'Não informado' }}
            </div>
          </div>
          <div class="col-3">
            <label class="resumo-show_label"
                   for="">Data do Registro</label>
            <div class="resumo-show_sublabel">
              {{ propData.registro.data_registro | date }}
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-2">
            <label class="resumo-show_label"
                   for="">Acervo</label>
            <div class="resumo-show_sublabel">
              {{ propData.registro.livro.acervo || 'Não informado' }}
            </div>
          </div>
          <div class="col-2">
            <label class="resumo-show_label"
                   for="">Livro</label>
            <div class="resumo-show_sublabel">
              {{ propData.registro.livro.num_livro || 'Não informado' }}
            </div>
          </div>
          <div class="col-2">
            <label class="resumo-show_label"
                   for="">Folha</label>
            <div class="resumo-show_sublabel">
              {{ propData.registro.folha || 'Não informado' }}
            </div>
          </div>
          <div class="col-2">
            <label class="resumo-show_label"
                   for="">Registro</label>
            <div class="resumo-show_sublabel">
              {{ propData.registro.termo || 'Não informado' }}
            </div>
          </div>
          <div class="col-2">
            <label class="resumo-show_label"
                   for="">Lado</label>
            <div class="resumo-show_sublabel">
              {{ propData.registro.lado || 'Não informado' }}
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <label class="resumo-show_label"
                   for="">Matrícula</label>
            <div class="resumo-show_sublabel">
              {{ propData.registro.matricula || 'Não informado' }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </collapse-default>
</template>

<script>
  import CollapseDefault from "./CollapseDefault"

  export default {
    name: "RegistroCollapse",
    components: {
      CollapseDefault
    },
    props: {
      propData: Object
    }
  }
</script>

<style scoped>

</style>
